import CronParser from 'cron-parser'
import { replaceWeekName } from './tabs/const'
import i18n from '@/i18n/i18n'

export default (rule, value, callback) => {
  // 没填写就不校验
  if (!value) {
    callback(new Error(i18n.t('easy_cron.validator.empty')))
    return true
  }
  const values = value.split(' ').filter(item => !!item)
  if (values.length > 7) {
    callback(new Error(i18n.t('easy_cron.validator.tooManyItems')))
    return false
  }
  // 检查第7项
  let e = value
  if (values.length === 7) {
    const year = replaceWeekName(values[6])
    if (year !== '*' && year !== '?') {
      let yearValues = []
      if (year.indexOf('-') >= 0) {
        yearValues = year.split('-')
      } else if (year.indexOf('/')) {
        yearValues = year.split('/')
      } else {
        yearValues = [year]
      }
      // console.info(yearValues)
      // 判断是否都是数字
      const checkYear = yearValues.some(item => isNaN(item))
      if (checkYear) {
        callback(new Error(i18n.t('easy_cron.validator.yearError', { year })))
        return false
      }
    }
    // 取其中的前六项
    e = values.slice(0, 6).join(' ')
  }
  // 6位 没有年
  // 5位没有秒、年
  let result = true
  try {
    const iter = CronParser.parseExpression(e)
    iter.next()
    callback()
  } catch (e) {
    callback(new Error(i18n.t('easy_cron.validator.parseError', { error: e })))
    result = false
  }
  return result
}



// WEBPACK FOOTER //
// ./src/components/easy_cron/validator.js